
<pre>
	<code><slot /></code>
</pre>

<style>
  pre {
    padding: 8px 4px;
    border-radius: 8px;
    font-size: 0.74rem;
    line-height: 1.1;
    max-width: 100%;
		width: 100%;
    overflow-x: auto;
    background: #ededed;
  }

	code {
    max-width: 100%;
  }
</style>